import React, { useEffect, useState } from 'react'
import { Card, Chip, Heading, LoadingFlex } from '@arnsbogroup/react-voicearchive'
import { useIntl } from 'react-intl'
import MemoryListBlock from 'components/MemoryListBlock'
import messages from './messages'

const FALLBACK_LOGO = 'https://voicearchive-branding.s3.eu-central-1.amazonaws.com/small-curve-white.svg'

const PublicMemorySharingPage = ({ match }) => {
  const { formatMessage } = useIntl()
  const hash = match.params.hash
  const [request, setRequest] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetch(`/rest/v2/memoryrequest/${hash}`)
      .then((r) => r.json())
      .then(({ success, data, errors }) => {
        if (!success) {
          setError((errors || []).join(', '))
          return
        }
        setRequest(data)
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false))
  }, [hash])

  const visibleMemories = (request?.memories || []).filter((m) => m.audio_download_url)

  const renderWithBranding = (content) => {
    const hasBranding = request?.brand != null
    const logo = request?.brand?.logo || request?.brand?.logo_dark || request?.brand?.icon || request?.brand?.banner || FALLBACK_LOGO
    const brandName = request?.brand?.displayName || request?.brand?.name || 'VoiceArchive'

    return (
      <div className="min-h-screen bg-gray-50 w-full">
        {hasBranding && (
          <div className="py-4 px-6 mb-8" style={{ backgroundColor: request?.brand?.theme?.primary?.default || '#326295' }}>
            <div className="max-w-2xl mx-auto flex items-center justify-center">
              <img
                src={logo}
                alt={brandName}
                className="h-10 object-contain"
                onError={(e) => { e.target.src = FALLBACK_LOGO }}
              />
            </div>
          </div>
        )}
        <div className="px-4 pb-12" style={hasBranding ? {} : { paddingTop: '2.5rem' }}>
          {content}
        </div>
      </div>
    )
  }

  if (loading) return <LoadingFlex />

  if (error || !request) {
    return renderWithBranding(
      <div className="max-w-2xl mx-auto text-center py-16">
        <p className="text-gray-500">{error || formatMessage(messages.notFound)}</p>
      </div>
    )
  }

  return renderWithBranding(
    <div className="max-w-2xl mx-auto space-y-6">
      <div className="space-y-3 text-center">
        <Heading level={1} className="text-2xl font-bold">
          {formatMessage(messages.pageTitle)}
        </Heading>
        {request.body && (
          <p className="text-gray-600 text-sm leading-relaxed">{request.body}</p>
        )}
        {visibleMemories.length > 0 && (
          <Chip size="sm" className="mx-auto">
            {formatMessage(messages.countChip, { count: visibleMemories.length })}
          </Chip>
        )}
      </div>

      {visibleMemories.length > 0 && (
        <Card className="p-4 text-sm text-gray-700 leading-relaxed">
          {formatMessage(messages.intro)}
        </Card>
      )}

      {visibleMemories.length === 0 && (
        <p className="text-center text-gray-400 text-sm py-8">
          {formatMessage(messages.noRecordings)}
        </p>
      )}

      {visibleMemories.length > 0 && (
        <MemoryListBlock
          title={formatMessage(messages.pageTitle)}
          memories={visibleMemories}
        />
      )}
    </div>
  )
}

export default PublicMemorySharingPage
